// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".locationname-locationcard-container{box-shadow:0 5px 10px 0 rgba(0,0,0,.5),8px 8px 30px 0 rgba(0,0,0,.5) !important;min-width:500px;z-index:1050}@media screen and (max-width: 576px){.locationname-locationcard-container{left:0;min-width:unset;position:fixed !important;width:100vw}}", ""]);
// Exports
module.exports = exports;
